// extracted by mini-css-extract-plugin
export default {"wrapperHidden":"CookieBar-module--wrapperHidden--6r+tL","wrapper":"CookieBar-module--wrapper--FfnDQ","container":"CookieBar-module--container--TBAov"};